import React from 'react';
import PropTypes from 'prop-types';

const Messenger = ({
	fill = '#9b9b9b',
	...props
}) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill={fill} {...props}>
		<path d="M12,0 C5.439,0 0.121,4.973 0.121,11.108 C0.121,14.598 1.842,17.712 4.534,19.748 L4.534,24 L8.588,21.751 C9.669,22.054 10.814,22.216 12,22.216 C18.561,22.216 23.879,17.243 23.879,11.108 C23.879,4.973 18.561,0 12,0 Z M13.251,14.896 L10.179,11.704 L4.262,14.976 L10.749,8.092 L13.821,11.284 L19.738,8.012 L13.251,14.896 Z"/>
	</svg>
);

Messenger.propTypes = {
	fill: PropTypes.string
};

export default Messenger;
